// extracted by mini-css-extract-plugin
export var boxIcons = "product-tour-module--boxIcons--f65b1";
export var epigraphBtn = "product-tour-module--epigraphBtn--4c85e";
export var getpricingcta = "product-tour-module--getpricingcta--4e4c4";
export var helperText = "product-tour-module--helperText--c9f25";
export var links = "product-tour-module--links--d18df";
export var mobileProductTourContainer = "product-tour-module--mobileProductTourContainer--a73b1";
export var picture = "product-tour-module--picture--fa074";
export var productTour = "product-tour-module--productTour--8297c";
export var productTourContainer = "product-tour-module--productTourContainer--05270";
export var productTourMobileButton = "product-tour-module--productTourMobileButton--fca87";
export var viewSauna = "product-tour-module--viewSauna--890ce";